export const getAppFullRoute = (pathname: string) => pathname.replace("/", "");

export const getAppRootRoute = (pathname: string) => pathname.split("/")[1];
